import { render } from "./YoutubeSummary.vue?vue&type=template&id=078581d8&scoped=true&ts=true"
import script from "./YoutubeSummary.vue?vue&type=script&lang=ts"
export * from "./YoutubeSummary.vue?vue&type=script&lang=ts"

import "./YoutubeSummary.vue?vue&type=style&index=0&id=078581d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078581d8"]])

export default __exports__